export enum CardBrandEnum {
	VISA = 'Visa',
	MASTERCARD = 'Mastercard',
	AMERICAN_EXPRESS = 'American express',
	DINERS = 'Diners'
}